export const SEARCH_LECTURES_QUERY_PARAM = 'search' as const
